import { z } from 'zod';
import { AMOUNT_SCHEMA } from '@monocle-money/zod-schema';
import { NOTE_MAX_LENGTH } from '../../../entities/CashTransaction/common/constants.ts';
import { LESS_THAN_SCHEMA, FIND_OPTIONS_ORDER_VALUE_SCHEMA } from '../../../common/schema.ts';

export const POST_SCHEMA = AMOUNT_SCHEMA.extend({
  to: z.number(),
  note: z.string().max(NOTE_MAX_LENGTH).optional(),
  lastTransactionId: z.number(),
});

const MIN_LIMIT = 3;
const MAX_LIMIT = 30;
export const DEFAULT_LIMIT = 10;
export const DEFAULT_ORDER = { createdAt: 'DESC' } as const;

export const GET_SCHEMA = z.object({
  where: z.array(
    z.object({
      id: LESS_THAN_SCHEMA.optional(),
      debitor: z.object({
        id: z.coerce.number(),
      }).optional(),
    }).merge(
      z.object({
        id: LESS_THAN_SCHEMA.optional(),
        creditor: z.object({
          id: z.coerce.number(),
        }).optional(),
      })
    )
  ).optional(),
  order: z.object({
    createdAt: FIND_OPTIONS_ORDER_VALUE_SCHEMA,
  }).optional(),
  take: z
    .coerce
    .number()
    .min(MIN_LIMIT)
    .max(MAX_LIMIT)
    .optional(),
});
